import React from 'react';

const CountrySelect = ({ 
  id, 
  name, 
  label, 
  value, 
  onChange, 
  required = false,
  ...props 
}) => {
  // Complete list of countries with ISO codes and Hungarian names
  const countries = [
    { code: 'AD', name: 'Andorra' },
    { code: 'AE', name: 'Egyesült Arab Emírségek' },
    { code: 'AF', name: 'Afganisztán' },
    { code: 'AG', name: 'Antigua és Barbuda' },
    { code: 'AI', name: 'Anguilla' },
    { code: 'AL', name: 'Albánia' },
    { code: 'AM', name: 'Örményország' },
    { code: 'AO', name: 'Angola' },
    { code: 'AQ', name: 'Antarktisz' },
    { code: 'AR', name: 'Argentína' },
    { code: 'AS', name: 'Amerikai Szamoa' },
    { code: 'AT', name: 'Ausztria' },
    { code: 'AU', name: 'Ausztrália' },
    { code: 'AW', name: 'Aruba' },
    { code: 'AX', name: 'Åland-szigetek' },
    { code: 'AZ', name: 'Azerbajdzsán' },
    { code: 'BA', name: 'Bosznia-Hercegovina' },
    { code: 'BB', name: 'Barbados' },
    { code: 'BD', name: 'Banglades' },
    { code: 'BE', name: 'Belgium' },
    { code: 'BF', name: 'Burkina Faso' },
    { code: 'BG', name: 'Bulgária' },
    { code: 'BH', name: 'Bahrein' },
    { code: 'BI', name: 'Burundi' },
    { code: 'BJ', name: 'Benin' },
    { code: 'BL', name: 'Saint-Barthélemy' },
    { code: 'BM', name: 'Bermuda' },
    { code: 'BN', name: 'Brunei' },
    { code: 'BO', name: 'Bolívia' },
    { code: 'BQ', name: 'Bonaire, Sint Eustatius és Saba' },
    { code: 'BR', name: 'Brazília' },
    { code: 'BS', name: 'Bahama-szigetek' },
    { code: 'BT', name: 'Bhután' },
    { code: 'BV', name: 'Bouvet-sziget' },
    { code: 'BW', name: 'Botswana' },
    { code: 'BY', name: 'Belarusz' },
    { code: 'BZ', name: 'Belize' },
    { code: 'CA', name: 'Kanada' },
    { code: 'CC', name: 'Kókusz (Keeling)-szigetek' },
    { code: 'CD', name: 'Kongói Demokratikus Köztársaság' },
    { code: 'CF', name: 'Közép-afrikai Köztársaság' },
    { code: 'CG', name: 'Kongó' },
    { code: 'CH', name: 'Svájc' },
    { code: 'CI', name: 'Elefántcsontpart' },
    { code: 'CK', name: 'Cook-szigetek' },
    { code: 'CL', name: 'Chile' },
    { code: 'CM', name: 'Kamerun' },
    { code: 'CN', name: 'Kína' },
    { code: 'CO', name: 'Kolumbia' },
    { code: 'CR', name: 'Costa Rica' },
    { code: 'CU', name: 'Kuba' },
    { code: 'CV', name: 'Zöld-foki Köztársaság' },
    { code: 'CW', name: 'Curaçao' },
    { code: 'CX', name: 'Karácsony-sziget' },
    { code: 'CY', name: 'Ciprus' },
    { code: 'CZ', name: 'Csehország' },
    { code: 'DE', name: 'Németország' },
    { code: 'DJ', name: 'Dzsibuti' },
    { code: 'DK', name: 'Dánia' },
    { code: 'DM', name: 'Dominika' },
    { code: 'DO', name: 'Dominikai Köztársaság' },
    { code: 'DZ', name: 'Algéria' },
    { code: 'EC', name: 'Ecuador' },
    { code: 'EE', name: 'Észtország' },
    { code: 'EG', name: 'Egyiptom' },
    { code: 'EH', name: 'Nyugat-Szahara' },
    { code: 'ER', name: 'Eritrea' },
    { code: 'ES', name: 'Spanyolország' },
    { code: 'ET', name: 'Etiópia' },
    { code: 'FI', name: 'Finnország' },
    { code: 'FJ', name: 'Fidzsi' },
    { code: 'FK', name: 'Falkland-szigetek' },
    { code: 'FM', name: 'Mikronézia' },
    { code: 'FO', name: 'Feröer-szigetek' },
    { code: 'FR', name: 'Franciaország' },
    { code: 'GA', name: 'Gabon' },
    { code: 'GB', name: 'Egyesült Királyság' },
    { code: 'GD', name: 'Grenada' },
    { code: 'GE', name: 'Grúzia' },
    { code: 'GF', name: 'Francia Guyana' },
    { code: 'GG', name: 'Guernsey' },
    { code: 'GH', name: 'Ghána' },
    { code: 'GI', name: 'Gibraltár' },
    { code: 'GL', name: 'Grönland' },
    { code: 'GM', name: 'Gambia' },
    { code: 'GN', name: 'Guinea' },
    { code: 'GP', name: 'Guadeloupe' },
    { code: 'GQ', name: 'Egyenlítői-Guinea' },
    { code: 'GR', name: 'Görögország' },
    { code: 'GS', name: 'Dél-Georgia és Dél-Sandwich-szigetek' },
    { code: 'GT', name: 'Guatemala' },
    { code: 'GU', name: 'Guam' },
    { code: 'GW', name: 'Bissau-Guinea' },
    { code: 'GY', name: 'Guyana' },
    { code: 'HK', name: 'Hongkong' },
    { code: 'HM', name: 'Heard-sziget és McDonald-szigetek' },
    { code: 'HN', name: 'Honduras' },
    { code: 'HR', name: 'Horvátország' },
    { code: 'HT', name: 'Haiti' },
    { code: 'HU', name: 'Magyarország' },
    { code: 'ID', name: 'Indonézia' },
    { code: 'IE', name: 'Írország' },
    { code: 'IL', name: 'Izrael' },
    { code: 'IM', name: 'Man-sziget' },
    { code: 'IN', name: 'India' },
    { code: 'IO', name: 'Brit Indiai-óceáni Terület' },
    { code: 'IQ', name: 'Irak' },
    { code: 'IR', name: 'Irán' },
    { code: 'IS', name: 'Izland' },
    { code: 'IT', name: 'Olaszország' },
    { code: 'JE', name: 'Jersey' },
    { code: 'JM', name: 'Jamaica' },
    { code: 'JO', name: 'Jordánia' },
    { code: 'JP', name: 'Japán' },
    { code: 'KE', name: 'Kenya' },
    { code: 'KG', name: 'Kirgizisztán' },
    { code: 'KH', name: 'Kambodzsa' },
    { code: 'KI', name: 'Kiribati' },
    { code: 'KM', name: 'Komorok' },
    { code: 'KN', name: 'Saint Kitts és Nevis' },
    { code: 'KP', name: 'Észak-Korea' },
    { code: 'KR', name: 'Dél-Korea' },
    { code: 'KW', name: 'Kuvait' },
    { code: 'KY', name: 'Kajmán-szigetek' },
    { code: 'KZ', name: 'Kazahsztán' },
    { code: 'LA', name: 'Laosz' },
    { code: 'LB', name: 'Libanon' },
    { code: 'LC', name: 'Saint Lucia' },
    { code: 'LI', name: 'Liechtenstein' },
    { code: 'LK', name: 'Srí Lanka' },
    { code: 'LR', name: 'Libéria' },
    { code: 'LS', name: 'Lesotho' },
    { code: 'LT', name: 'Litvánia' },
    { code: 'LU', name: 'Luxemburg' },
    { code: 'LV', name: 'Lettország' },
    { code: 'LY', name: 'Líbia' },
    { code: 'MA', name: 'Marokkó' },
    { code: 'MC', name: 'Monaco' },
    { code: 'MD', name: 'Moldova' },
    { code: 'ME', name: 'Montenegró' },
    { code: 'MF', name: 'Saint-Martin' },
    { code: 'MG', name: 'Madagaszkár' },
    { code: 'MH', name: 'Marshall-szigetek' },
    { code: 'MK', name: 'Észak-Macedónia' },
    { code: 'ML', name: 'Mali' },
    { code: 'MM', name: 'Mianmar' },
    { code: 'MN', name: 'Mongólia' },
    { code: 'MO', name: 'Makaó' },
    { code: 'MP', name: 'Északi Mariana-szigetek' },
    { code: 'MQ', name: 'Martinique' },
    { code: 'MR', name: 'Mauritánia' },
    { code: 'MS', name: 'Montserrat' },
    { code: 'MT', name: 'Málta' },
    { code: 'MU', name: 'Mauritius' },
    { code: 'MV', name: 'Maldív-szigetek' },
    { code: 'MW', name: 'Malawi' },
    { code: 'MX', name: 'Mexikó' },
    { code: 'MY', name: 'Malajzia' },
    { code: 'MZ', name: 'Mozambik' },
    { code: 'NA', name: 'Namíbia' },
    { code: 'NC', name: 'Új-Kaledónia' },
    { code: 'NE', name: 'Niger' },
    { code: 'NF', name: 'Norfolk-sziget' },
    { code: 'NG', name: 'Nigéria' },
    { code: 'NI', name: 'Nicaragua' },
    { code: 'NL', name: 'Hollandia' },
    { code: 'NO', name: 'Norvégia' },
    { code: 'NP', name: 'Nepál' },
    { code: 'NR', name: 'Nauru' },
    { code: 'NU', name: 'Niue' },
    { code: 'NZ', name: 'Új-Zéland' },
    { code: 'OM', name: 'Omán' },
    { code: 'PA', name: 'Panama' },
    { code: 'PE', name: 'Peru' },
    { code: 'PF', name: 'Francia Polinézia' },
    { code: 'PG', name: 'Pápua Új-Guinea' },
    { code: 'PH', name: 'Fülöp-szigetek' },
    { code: 'PK', name: 'Pakisztán' },
    { code: 'PL', name: 'Lengyelország' },
    { code: 'PM', name: 'Saint-Pierre és Miquelon' },
    { code: 'PN', name: 'Pitcairn-szigetek' },
    { code: 'PR', name: 'Puerto Rico' },
    { code: 'PS', name: 'Palesztina' },
    { code: 'PT', name: 'Portugália' },
    { code: 'PW', name: 'Palau' },
    { code: 'PY', name: 'Paraguay' },
    { code: 'QA', name: 'Katar' },
    { code: 'RE', name: 'Réunion' },
    { code: 'RO', name: 'Románia' },
    { code: 'RS', name: 'Szerbia' },
    { code: 'RU', name: 'Oroszország' },
    { code: 'RW', name: 'Ruanda' },
    { code: 'SA', name: 'Szaúd-Arábia' },
    { code: 'SB', name: 'Salomon-szigetek' },
    { code: 'SC', name: 'Seychelle-szigetek' },
    { code: 'SD', name: 'Szudán' },
    { code: 'SE', name: 'Svédország' },
    { code: 'SG', name: 'Szingapúr' },
    { code: 'SH', name: 'Szent Ilona' },
    { code: 'SI', name: 'Szlovénia' },
    { code: 'SJ', name: 'Svalbard és Jan Mayen' },
    { code: 'SK', name: 'Szlovákia' },
    { code: 'SL', name: 'Sierra Leone' },
    { code: 'SM', name: 'San Marino' },
    { code: 'SN', name: 'Szenegál' },
    { code: 'SO', name: 'Szomália' },
    { code: 'SR', name: 'Suriname' },
    { code: 'SS', name: 'Dél-Szudán' },
    { code: 'ST', name: 'São Tomé és Príncipe' },
    { code: 'SV', name: 'Salvador' },
    { code: 'SX', name: 'Sint Maarten' },
    { code: 'SY', name: 'Szíria' },
    { code: 'SZ', name: 'Szváziföld' },
    { code: 'TC', name: 'Turks- és Caicos-szigetek' },
    { code: 'TD', name: 'Csád' },
    { code: 'TF', name: 'Francia Déli Területek' },
    { code: 'TG', name: 'Togo' },
    { code: 'TH', name: 'Thaiföld' },
    { code: 'TJ', name: 'Tádzsikisztán' },
    { code: 'TK', name: 'Tokelau' },
    { code: 'TL', name: 'Kelet-Timor' },
    { code: 'TM', name: 'Türkmenisztán' },
    { code: 'TN', name: 'Tunézia' },
    { code: 'TO', name: 'Tonga' },
    { code: 'TR', name: 'Törökország' },
    { code: 'TT', name: 'Trinidad és Tobago' },
    { code: 'TV', name: 'Tuvalu' },
    { code: 'TW', name: 'Tajvan' },
    { code: 'TZ', name: 'Tanzánia' },
    { code: 'UA', name: 'Ukrajna' },
    { code: 'UG', name: 'Uganda' },
    { code: 'UM', name: 'Egyesült Államok lakatlan külbirtokai' },
    { code: 'US', name: 'Egyesült Államok' },
    { code: 'UY', name: 'Uruguay' },
    { code: 'UZ', name: 'Üzbegisztán' },
    { code: 'VA', name: 'Vatikán' },
    { code: 'VC', name: 'Saint Vincent és a Grenadine-szigetek' },
    { code: 'VE', name: 'Venezuela' },
    { code: 'VG', name: 'Brit Virgin-szigetek' },
    { code: 'VI', name: 'Amerikai Virgin-szigetek' },
    { code: 'VN', name: 'Vietnám' },
    { code: 'VU', name: 'Vanuatu' },
    { code: 'WF', name: 'Wallis és Futuna' },
    { code: 'WS', name: 'Szamoa' },
    { code: 'YE', name: 'Jemen' },
    { code: 'YT', name: 'Mayotte' },
    { code: 'ZA', name: 'Dél-afrikai Köztársaság' },
    { code: 'ZM', name: 'Zambia' },
    { code: 'ZW', name: 'Zimbabwe' }
  ];

  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <div className="country-select-group">
      {label && (
        <label 
          htmlFor={id || name} 
          className="country-select-label"
          style={label === "Receiver Country" ? { fontWeight: 'normal' } : {}}
        >
          {label}
        </label>
      )}
      <select
        id={id || name}
        name={name}
        value={value}
        onChange={handleChange}
        required={required}
        className="country-select"
        {...props}
      >
        <option value="">Válasszon országot...</option>
        {countries.map((country) => (
          <option key={country.code} value={country.code}>
            {country.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CountrySelect;
